<template>
	<div class="w1200 flex wrap photos">
		<div v-loading="loading"  :element-loading-text="$t('拼命加载中')">
			<div class="flex wrap" v-if="img_list.length > 0">
			  <template v-for="(item,index) in img_list">
				  <!-- <div class="photos_0">
					  <img  :src="item.thumb" alt="" srcset="" :preview-src-list="img_list">
				  </div> -->
				  <div class="photos_0 demo-image__preview">
				    <el-image 
				      style="width: 278px;height: 278px;"
				      :src="item.thumb" 
				      :preview-src-list="igs_list">
				    </el-image>
				  </div>
			  </template>
			</div>
			<div v-else style="text-align: center;padding: 40px 0;">
				<img style="width: 217px;height: 177px;" src="https://api.ezlunch.club/pc/image/29.png" alt="" srcset="">
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {
				loading:true,
				img_list:[],
				igs_list:[]
			}
		},
		created() {
			this.post641e624160dd0()
		},

		methods: {
			gengxin(){
				this.loading = true
				this.post641e624160dd0()
			},
			// 轮播图
			post641e624160dd0(){
				this.$api.post(this.$apiUrls.post641e624160dd0,{type:4}).then((res) => {
					if(res.code == 1){
						this.img_list = res.data
						let list = []
						for (var i = 0; i < this.img_list.length; i++) {
							list.push(this.img_list[i].thumb) 
						}
						this.igs_list = list
						
						this.loading = false
					}else{
						this.$message.error(res.msg);
						return
					}
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	::v-deep {
		.el-loading-mask {
			width: 1200px;
			opacity: 1 !important; 
			background-color: rgba(255, 255, 255, 1) !important;
		}
	}
	.photos{
		background: #fff;
		border-radius: 8px;
		margin: 20px auto 0;
		padding: 20px 0 50px 4px;
	}
	.photos_0{
		width: 278px;
		height: 278px;
		margin: 0px 0 16px 16px;
		img{
			width: 278px;
			height: 278px;
		}
	}

	
</style>